import { PageHeader } from "@/CommonElements/PageTitle";
import { Container } from "reactstrap";
import { useCreateInitialCampaignMutation } from "../../../services/campaigns";
import { useTranslation } from "react-i18next";
import { InitialCampaignForm } from "./InitialCampaignForm";
import { Button } from "react-bootstrap";
import { Spinner } from "reactstrap";
import { useForm, FormProvider } from "react-hook-form";
import { FormActionsFooter } from "@/Component/FormActionsFooter";
import { handleFormErrors } from "@/utils/helpers";
import { useSystem } from "@/utils/hooks/useLocation";

export const CreateInitialCampaign = () => {
  const { t } = useTranslation();
  const { currentSystem } = useSystem();
  // controllerProps, labelProps, layout
  const { mutate: createInitialCampaign, isPending } =
    useCreateInitialCampaignMutation({currentSystem});
  const form = useForm({
    defaultValues: {
      country_id: "98",
      nationality_id: 98,
    },
  });

  const { handleSubmit } = form;

  // ==================
  // Handlers
  // ==================
  const onSubmit = (data) => {
    createInitialCampaign(data, {
      onSuccess: () => {
        form.reset();
      },
      onError: (error) => {
        handleFormErrors(
          error,
          form.setError,
          t,
          "INITIAL_CAMPAIGN_CREATION_FAILED"
        );
      },
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(onSubmit)(e);
  };

  return (
    <div>
      <PageHeader
        title={t("CREATE_INITIAL_CAMPAIGN")}
        backTo={`/app/${currentSystem}/arrival-campaign`}
      />
      <Container fluid>
        <form onSubmit={handleFormSubmit}>
          <FormProvider {...form}>
            <InitialCampaignForm />
          </FormProvider>

          <FormActionsFooter>
            <Button variant="primary" type="submit" disabled={isPending}>
              {isPending && <Spinner size="sm" className="me-2" />}
              {t("CREATE_INITIAL_CAMPAIGN")}
            </Button>
          </FormActionsFooter>
        </form>
      </Container>
    </div>
  );
};
